import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { resetUnitAsync } from 'store/units/index';
import { useUnit } from 'hooks/units/index';

import { getSelectedCentre } from 'store/master';
import useI18n from 'hooks/use-i18n';
import { handleToastError } from 'helpers/index';
import { getColor, getColorText } from 'store/settings';
import { COURSE_STATUS } from 'constants/constants';

const ButtonNotPassed = () => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const unitSelected = useUnit();
  const { query } = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const selectedCentre = useSelector(getSelectedCentre);
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const handleResetUnit = async () => {
    try {
      let param = {};
      if (selectedCentre?._id) {
        param.centreId = selectedCentre?._id;
      }
      if (
        selectedCentre?.reviewContent ||
        selectedCentre?.reviewContent === undefined
      ) {
        param.reviewContent = true;
      }
      setIsLoading(true);
      await dispatch(resetUnitAsync(unitSelected._id, query?.slug, param));
      window.location.reload();
    } catch (e) {
      setIsLoading(false);
      handleToastError(e, i18n);
    }
  };

  return (
    <button
      className="btn-bg-color"
      onClick={handleResetUnit}
      disabled={isLoading || isDisabled}
      style={{
        backgroundColor: `${colorStatus}`,
        color: `${colorTextStatus}`,
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'white';
        e.target.style.borderColor = colorStatus;
        e.target.style.color = colorStatus;
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = colorStatus;
        e.target.style.color = colorTextStatus;
      }}
    >
      You did not pass. Click to try again.
    </button>
  );
};

export default ButtonNotPassed;
